import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initScrollDepthTracking, initSectionVisibilityTracking, initClarityTags } from './lib/analytics'

// Wire up scroll_50 / scroll_90 events to all configured pixels (GA4, Meta, TikTok).
// page_view fires automatically when GA/Meta/TikTok scripts load (see index.html).
initScrollDepthTracking();
// Tag Clarity sessions (internal-traffic exclusion + page_type segment).
initClarityTags();
initSectionVisibilityTracking([
  'hero',
  'about',
  'inside',
  'preview',
  'buy',
  'faq',
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
